class MainNav {
	constructor() {
		this.init();
	}

	init() {
        const $this = this;
        
        $("body").on( "click",function(e) {
            // check if the main nav item with children li, or its direct <a is being clicked
            const mainMenu = $('.menu-item-has-children');
            const mainMenuA = $('.menu-item-has-children > a');
            
            if( mainMenu.is(e.target) || mainMenuA.is(e.target)){
                e.preventDefault();

                // identify the li
                const target = mainMenu.is(e.target) ? e.target : $(e.target).parent();
                
                // close all other sub menus
                mainMenu.not(target).removeClass('is-active');
                
                // toggle the current sub menu
                $(target).toggleClass('is-active');

            }else{
                // check if a sub menu (or item within sub menu) is being clicked
                const subMenu = $('.sub-menu');
                if (!subMenu.is(e.target) && !subMenu.has(e.target).length) {
                    $this.closeSubMenus();
                }
            }
        });

        // make menu closable with escape key
        document.onkeydown = function(evt) { 
            evt = evt || window.event; 
            let isEscape = false; 
            if ("key" in evt) { 
                isEscape = (evt.key === "Escape" || evt.key === "Esc"); 
            } else { 
                isEscape = (evt.keyCode === 27); 
            } 

            if (isEscape) { 
                $this.closeSubMenus();
            } 
        }; 
	}
    closeSubMenus(){
        $('.menu-item-has-children.is-active').removeClass('is-active')
    }
}
export default MainNav;
